<template>
	<b-form-group
        :key="label"
        :label-for="label"
        :required="required"
        :label-size="size"
        >
        <b-input-group :prepend="label"
        	:size="size">
            <b-form-input
        		:size="size"
                :placeholder="placeholder"
                :required="required"
                :type="type"
                v-model="input"
            ></b-form-input>
        </b-input-group>
    </b-form-group>
</template>

<script>
	export default{
		props: {
			type: {
				type: String,
				default: "text"
			},
			label: {
				type: String,
				default: "Form Label"
			},
			required: {
				type: Boolean,
				default: false
			},
			size: {
				type: String,
				default: "md"
			},
			placeholder: {
				type: String
			}
		},
		data() {
			return {
				input: ""
			}
		}
	}
</script>

<style scoped>
	.input-group-text, input[placeholder] {
		justify-content: center;
		width: 89px;
		font-size: 0.8rem;
		font-weight: 500;
	}
	.form-group {
		margin-bottom: 0.3rem;
	}
	@media only screen and (max-width: 600px) {
		.input-group-text, input[placeholder] {
			justify-content: center;
			width: 69px;
			font-size: 0.8rem;
			font-weight: 500;
		}
		.form-group {
			margin-bottom: 0.1rem;
		}
	}
</style>